import { gql } from '@apollo/client';

const ERRORS = `errors { path, message }`;

const LIBRARY_CORE_FIELDS = gql`
  fragment LibraryCoreFields on Library {
    id
    name
    description
    access
  }
`;

export const LIBRARY_FIELDS = gql`
  ${LIBRARY_CORE_FIELDS}
  fragment LibraryFields on Library {
    ...LibraryCoreFields
    owner
  }
`;

export const LIBRARY = gql`
  ${LIBRARY_FIELDS}
  query Library($id: ID!) {
    library(id: $id) {
      ...LibraryFields
      eventTypes { id, name }
      things { id, name }
    }
  }
`;

export const LIBRARIES = gql`
  ${LIBRARY_FIELDS}
  query Libraries (
    $limit: Int!
    $offset: String!
    $options: ConnectionOptionsInput!
  ) {
    libraries (
      first: $limit
      after: $offset
      options: $options
    ) {
      edges {
        cursor
        node {
          ...LibraryFields
        }
      }
      totalCount
    }
  }
`;

export const CREATE_LIBRARY = gql`
  ${LIBRARY_CORE_FIELDS}
  mutation CreateLibrary ($input: CreateLibraryInput!) {
    createLibrary (input: $input) {
      library {
        ...LibraryCoreFields
      }
      ${ERRORS}
    }
  }
`;

export const UPDATE_LIBRARY = gql`
  ${LIBRARY_CORE_FIELDS}
  mutation UpdateLibrary ($input: UpdateLibraryInput!) {
    updateLibrary (input: $input) {
      library {
        ...LibraryCoreFields
      }
      ${ERRORS}
    }
  }
`;
